import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { PublicContentSection } from '../../../../../../../api/src/content-section/content-section.entity';
import { ContentSectionOpenEvent } from '../content-section.model';
import { PublicCreativeUnitPackageListing } from '../../../../../../../api/src/creative-unit-package-listing/creative-unit-package-listing.entity';
import { ProjectsQuery } from '../../project';
import { SelectedPartialListingEvent } from '../../../../pages/project/project.page';
import { ObjectUtils } from '../../../../../../../api/src/_core/utils/utils.object';

@Component({
	selector: 'app-content-section',
	templateUrl: './content-section.component.html',
	styleUrls: ['./content-section.component.scss']
})
export class ContentSectionComponent implements OnInit, OnChanges {
	@Input() contentSection: PublicContentSection;
	@Input() adminMode: boolean = false;
	@Input() isPreviewMode: boolean = false;
	@Input() preloadedListings: PublicCreativeUnitPackageListing[]; // For preview mode: avoid duplicate API calls

	@Output() openDialog: EventEmitter<ContentSectionOpenEvent> = new EventEmitter();
	@Output() delete: EventEmitter<PublicContentSection> = new EventEmitter();
	@Output() customEvent: EventEmitter<{ name: string; args: any[] }> = new EventEmitter();
	@Output() moveUp: EventEmitter<PublicContentSection> = new EventEmitter();
	@Output() moveDown: EventEmitter<PublicContentSection> = new EventEmitter();

	@Output() selectedListing: EventEmitter<PublicCreativeUnitPackageListing> = new EventEmitter();
	@Output() selectedPartialListing: EventEmitter<SelectedPartialListingEvent> = new EventEmitter<SelectedPartialListingEvent>();

	@ViewChild('bodyElement', { static: false }) bodyElement: ElementRef;

	public body: string;

	constructor(
		public readonly projectsQuery: ProjectsQuery
	) {}

	ngOnChanges(changes: SimpleChanges): void {
        if (this.isPreviewMode && changes['contentSection']) {
			this.ngOnInit();
			if (this.contentSection.templates?.enabled && changes.contentSection.previousValue && !ObjectUtils.compareObjectsByProperties(changes.contentSection.previousValue, this.contentSection, ['body', 'title', 'subtitle', 'name', 'locale'], true)) {
				// recreate component to refresh templates
				this.contentSection.templates.enabled = false;
				setTimeout(() => {
					this.contentSection.templates.enabled = true;
				}, 0);
			}
		}
    }

	ngOnInit(): void {
		// Unescape all html tags\
		if (this.contentSection.body) {
			this.body = this.contentSection.body
				.replace(/&lt;/g, '<')
				.replace(/&gt;/g, '>')
				.replace(/&quot;/g, '"')
				.replace(/&#039;/g, "'");
		} else {
			this.body = undefined;
		}
	}

	ngOnDestroy(): void {
		this.body = '';
	}

	/**
	 * Look for custom events within the body html and emit them.
	 * Authors can apply the data-event and data-args attributes to any element within the body to trigger custom events.
	 * @param event
	 */
	handleContainerClick(event: Event): void {
		let target = event.target as Element;
		let eventName = target.getAttribute('data-event');
		let args = target.getAttribute('data-args')?.split(',') || [];

		while (!eventName && target !== this.bodyElement.nativeElement) {
			target = target.parentElement;
			eventName = target?.getAttribute('data-event');
			args = target?.getAttribute('data-args')?.split(',') || [];
		}

		if (eventName) {
			this.customEvent.emit({ name: eventName, args });
		}
	}
}
